import $ from 'jquery';

const SideMenu = (el) => {
    const $el = $(el);
    const $content = $el.find('.js-sidemenu-content');
    const $buttons = $el.find('.js-sidemenu-toggle');
    const $item = $el.find('.js-report-nav-item');
    const $width = (window.innerWidth > 0) ? window.innerWidth : screen.width;


    $buttons.click(function (e) {
        e.preventDefault();

        $buttons.toggleClass('js-state-sidemenu--open');
        $content.slideToggle();
    });

    $item.click(function () {
        if($width < 1024) {
            $buttons.toggleClass('js-state-sidemenu--open');
            $content.slideToggle();
        }
    });
};

export default SideMenu;
